import React, { useMemo } from 'react';

import { CashbackClaimingFrequencyKeys, LevelConditionShortKeys, T } from '../../../../../constants';
import { formatDate, getLevelConditionValues, setTranslationValues } from '../../../../../helpers';
import { useTranslation } from '../../../../../hooks';
import { CashbackInfo } from '../../../../../models';

interface RewardsDetailedPopupRulesTabProps {
  data: CashbackInfo;
  currencyCode: string;
}

export const RewardsDetailedPopupRulesTab: React.FC<RewardsDetailedPopupRulesTabProps> = ({ data, currencyCode }) => {

  const t = useTranslation();

  const rulesContent = useMemo(() => {
    const { claimingCountPerUser, claimingFrequency, startDate, endDate, levels } = data;
    
    // dates or budget dynamic sentence
    const hasBudget = !!data.budgetAmount;
    const budgetLeft = `${data.remainingBudgetAmount} ${currencyCode} `;
    const cashbackInfoDatesOrBudgetKey = hasBudget ? T.CASHBACK_INFO_REMAINING_BUDGET : T.CASHBACK_INFO_DATES;
    const cashbackInfoDatesOrBudgetTr = setTranslationValues(t(cashbackInfoDatesOrBudgetKey), {
      endDate: formatDate(new Date(endDate)),
      startDate: formatDate(new Date(startDate)),
      budgetLeft
    });

    const translationVariables = {
      claimingCountPerUser,
      datesOrBudget: cashbackInfoDatesOrBudgetTr,
      rewardsLevels: levels.reduce<string>((acc, curr) => {
        return acc + setTranslationValues(t(T.REWARDS_RICH_LEVEL), {
          level: curr.level,
          rewardAmount: `${curr.rewardAmount} ${currencyCode}`,
          goal: setTranslationValues(t(LevelConditionShortKeys[curr.levelConditionType]), getLevelConditionValues(curr, currencyCode)),
          accumulationMinOdd: curr.accumulationMinOdd === null ? '' : setTranslationValues(t(T.CASHBACK_ACCULATION_MIN_ODD), { minOdd: `x${curr.accumulationMinOdd}` }),
          accumulationMinBetAmount: curr.accumulationMinBetAmount === null ? '' : setTranslationValues(t(T.CASHBACK_ACCULATION_MIN_BET_AMOUNT), { minBetAmount: `${curr.accumulationMinBetAmount} ${currencyCode}` }),
        });
      }, ''),
      claimingFrequency: claimingFrequency === null ? '' : t(CashbackClaimingFrequencyKeys[claimingFrequency])
    };

    return { __html: setTranslationValues(t(T.REWARDS_RICH_RULES), translationVariables) };
  }, [t, data, currencyCode]);

  return (
    <div className="rewards-body-rule-wrapper">
      <p className="rewards-rule-text" dangerouslySetInnerHTML={rulesContent}></p>
    </div >
  );
};
